/* eslint-disable max-len */
import React, { useState } from 'react'
import { navigate } from 'gatsby'
import styled, { css } from 'styled-components'
import { colors, device } from '../styles/config'

const SvgContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;

  @media ${ device.sm } {
    position: initial;
    width: initial;
    margin-left: -2rem;
    margin-right: -2rem;
  }

  svg {
    width: 100%;
    height: 100%;
    /* position: absolute; */

    @media ${ device.sm } {
      width: 200%;
      margin-left: -15%;
    }
    
    @media ${ device.xs } {
      width: 275%;
      margin-left: -35%;
    }
  }
`

const RoomPin = styled.g`
  z-index: 1;
  pointer-events: bounding-box;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s, visibility 0.5s;
  
  use {
    transform: scale(1.4) translateY(-5px);
    /* transform-origin: top center; */
  }

  @media ${ device.lg } {
    use {
      transform: scale(1.7) translateY(-5px);
    }
  }

  @media ${ device.md } {
    use {
      transform: scale(2.1) translateY(-5px);
    }
  }

  @media ${ device.sm } {
    use {
      transform: scale(2.2) translateY(-5px);
    }
  }

  @media ${ device.xs } {
    use {
      transform: scale(2.5) translateY(-5px);
    }
  }

  &#inselgarten-pin {
    display: ${ props => props.activeRoom === 'wiese' && 'none' };
  }

  &#theaterdeck-pin {
    display: ${ props => props.activeRoom === 'theaterdeck' && 'none' };
  }

  &#brueckendeck-pin {
    display: ${ props => props.activeRoom === 'brueckendeck' && 'none' };
  }

  &#sonnendeck-pin {
    display: ${ props => props.activeRoom === 'sonnendeck' && 'none' };
  }
`

const RoomText = styled.g`
  &#inselgarten-text {
    display: ${ props => props.activeRoom === 'wiese' && 'none' };
  }
  &#theaterdeck-text {
    display: ${ props => props.activeRoom === 'theaterdeck' && 'none' };
  }
  &#brueckendeck-text {
    display: ${ props => props.activeRoom === 'brueckendeck' && 'none' };
  }
  &#sonnendeck-text {
    display: ${ props => props.activeRoom === 'sonnendeck' && 'none' };
  }
`

const Room = styled.g`
  z-index: 1;

  &#inselgarten {
    > path:first-child, > g {
      transition: opacity 0.5s, visibility 0.5s;
      opacity: 0;
      visibility: hidden;
    }
  }

  &#theaterdeck {
    > polygon:nth-child(1),
    > polygon:nth-child(2),
    > g:last-child {
      transition: opacity 0.5s, visibility 0.5s;
      opacity: 0;
      visibility: hidden;
    }
  }

  &#brueckendeck {
    > polygon:nth-child(1),
    > polygon:nth-child(2),
    > g {
      transition: opacity 0.5s, visibility 0.5s;
      opacity: 0;
      visibility: hidden;
    }
  }

  &#sonnendeck {
    > polygon:nth-child(1),
    > polygon:nth-child(2),
    > polygon:nth-child(3),
    > g {
      transition: opacity 0.5s, visibility 0.5s;
      opacity: 0;
      visibility: hidden;
    }
  }
`

const RoomGroup = styled.g`
  cursor: pointer;

  @media ${ device.hover } {
    &:hover {
      z-index: 9999
    }
  }

  #inselgarten {
    ${ props => props.activeRoom === 'wiese' && css`
      > path:first-child {
        opacity: 0.450;
        visibility: visible;
      }

      > g {
        opacity: 1;
        visibility: visible;
      }
    ` }
  }


  #theaterdeck {
    ${ props => props.activeRoom === 'theaterdeck' && css`
      > polygon:nth-child(1) {
        opacity: 0.598;
        visibility: visible;
      }

      > polygon:nth-child(2) {
        opacity: 0.485;
        visibility: visible;
      }

      > g:last-child {
        opacity: 1;
        visibility: visible;
      }
    ` }
  }


  #brueckendeck {
    ${ props => props.activeRoom === 'brueckendeck' && css`
      > polygon:nth-child(1) {
        opacity: 0.774;
        visibility: visible;
      }

      > polygon:nth-child(2) {
        opacity: 0.468;
        visibility: visible;
      }

      > g {
        opacity: 1;
        visibility: visible;
      }
    ` }
  }


  #sonnendeck {
    ${ props => props.activeRoom === 'sonnendeck' && css`
      > polygon:nth-child(1) {
        opacity: 0.467;
        visibility: visible;
      }

      > polygon:nth-child(2) {
        opacity: 0.612;
        visibility: visible;
      }

      > polygon:nth-child(3) {
        opacity: 0.322;
        visibility: visible;
      }

      > g {
        opacity: 1;
        visibility: visible;
      }
    ` }
  }

  @media ${ device.hover } {
    &:hover {
      ${ RoomPin } {
        opacity: 0;
        visibility: hidden;
      }

      #inselgarten {
        > path:first-child {
          opacity: 0.450;
          visibility: visible;
        }

        > g {
          opacity: 1;
          visibility: visible;
        }
      }

      #theaterdeck {
        > polygon:nth-child(1) {
          opacity: 0.598;
          visibility: visible;
        }

        > polygon:nth-child(2) {
          opacity: 0.485;
          visibility: visible;
        }

        > g:last-child {
          opacity: 1;
          visibility: visible;
        }
      }

      #brueckendeck {
        > polygon:nth-child(1) {
          opacity: 0.774;
          visibility: visible;
        }

        > polygon:nth-child(2) {
          opacity: 0.468;
          visibility: visible;
        }

        > g {
          opacity: 1;
          visibility: visible;
        }
      }

      #sonnendeck {
        > polygon:nth-child(1) {
          opacity: 0.467;
          visibility: visible;
        }

        > polygon:nth-child(2) {
          opacity: 0.612;
          visibility: visible;
        }

        > polygon:nth-child(3) {
          opacity: 0.322;
          visibility: visible;
        }

        > g {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

`

const House = ({ activeRoom }) => {
  const onRoomClick = room => {
    navigate(`/vermietung/${ room }`)
  }

  return (
    <SvgContainer>
      {/* <SvgContainerInner> */}
      <svg viewBox="0 0 1940 756">
        <defs>
          <linearGradient
            x1="38.3747178%"
            y1="71.1635165%"
            x2="55.2044674%"
            y2="26.0243082%"
            id="linearGradient-1"
          >
            <stop stopColor="#EB9164" offset="0%" />
            <stop stopColor="#44B1EC" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="48.7186145%"
            y1="1.28138548%"
            x2="48.7186145%"
            y2="98.7186145%"
            id="linearGradient-2"
          >
            <stop stopColor="#8088AE" offset="0%" />
            <stop stopColor="#F5F5F7" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="25.2404865%"
            y1="42.6872706%"
            x2="-12.8706404%"
            y2="39.5387992%"
            id="linearGradient-3"
          >
            <stop stopColor="#FFFFFF" stopOpacity={0} offset="0%" />
            <stop stopColor="#FFFFFF" offset="54.0540541%" />
            <stop stopColor="#FFFFFF" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="25.3921837%"
            y1="48.0991%"
            x2="97.437229%"
            y2="50%"
            id="linearGradient-4"
          >
            <stop stopColor="#BEC4E2" offset="0%" />
            <stop stopColor="#F5F5F7" offset="100%" />
          </linearGradient>
          <linearGradient
            x1="14.5212283%"
            y1="47.0489738%"
            x2="45.2121322%"
            y2="48.8403231%"
            id="linearGradient-5"
          >
            <stop stopColor="#FFFFFF" offset="0%" />
            <stop
              stopColor="#F9F9FA"
              stopOpacity={0.352546088}
              offset="67.5675676%"
            />
            <stop stopColor="#F5F5F7" stopOpacity={0} offset="100%" />
          </linearGradient>
          <linearGradient
            x1="-10.1631221%"
            y1="72.5367273%"
            x2="66.6078557%"
            y2="45.1183388%"
            id="linearGradient-6"
          >
            <stop stopColor="#9ECDE3" offset="0%" />
            <stop stopColor="#5293CF" offset="100%" />
          </linearGradient>
          <polygon
            id="path-7"
            points="0 0 205.155688 0 229.683594 53.4048507 205.155688 100 0 100"
          />
          <filter
            x="-7.6%"
            y="-22.5%"
            width="123.9%"
            height="155.0%"
            filterUnits="objectBoundingBox"
            id="filter-8"
          >
            <feOffset dx={10} dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation={7.5}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.196078431   0 0 0 0 0.239215686   0 0 0 0 0.454901961  0 0 0 0.0993263134 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <circle id="path-9" cx={14} cy={14} r={14} />
          <filter
            x="-37.5%"
            y="-37.5%"
            width="175.0%"
            height="175.0%"
            filterUnits="objectBoundingBox"
            id="filter-10"
          >
            <feMorphology
              radius={1.5}
              operator="dilate"
              in="SourceAlpha"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dx={0}
              dy={0}
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation={3}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.340772509 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <linearGradient
            x1="100%"
            y1="47.1315029%"
            x2="2.77396537%"
            y2="55.2236117%"
            id="linearGradient-11"
          >
            <stop stopColor="#FEB903" offset="0%" />
            <stop stopColor="#FF7503" offset="100%" />
          </linearGradient>
          <polygon
            id="path-12"
            points="0 0 205.155688 0 229.683594 53.4048507 205.155688 100 0 100"
          />
          <filter
            x="-7.6%"
            y="-22.5%"
            width="123.9%"
            height="155.0%"
            filterUnits="objectBoundingBox"
            id="filter-13"
          >
            <feOffset dx={10} dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation={7.5}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.196078431   0 0 0 0 0.239215686   0 0 0 0 0.454901961  0 0 0 0.0993263134 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <circle id="path-14" cx={14} cy={14} r={14} />
          <filter
            x="-37.5%"
            y="-37.5%"
            width="175.0%"
            height="175.0%"
            filterUnits="objectBoundingBox"
            id="filter-15"
          >
            <feMorphology
              radius={1.5}
              operator="dilate"
              in="SourceAlpha"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dx={0}
              dy={0}
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation={3}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.340772509 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <linearGradient
            x1="70.262927%"
            y1="50.0031532%"
            x2="0.66279929%"
            y2="55.9326748%"
            id="linearGradient-16"
          >
            <stop stopColor="#E93636" offset="0.0527871622%" />
            <stop stopColor="#C6614B" offset="100%" />
          </linearGradient>
          <polygon
            id="path-17"
            points="0 0 205.155688 0 229.683594 53.4048507 205.155688 100 0 100"
          />
          <filter
            x="-7.6%"
            y="-22.5%"
            width="123.9%"
            height="155.0%"
            filterUnits="objectBoundingBox"
            id="filter-18"
          >
            <feOffset dx={10} dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation={7.5}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.196078431   0 0 0 0 0.239215686   0 0 0 0 0.454901961  0 0 0 0.0993263134 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <circle id="path-19" cx={14} cy={14} r={14} />
          <filter
            x="-37.5%"
            y="-37.5%"
            width="175.0%"
            height="175.0%"
            filterUnits="objectBoundingBox"
            id="filter-20"
          >
            <feMorphology
              radius={1.5}
              operator="dilate"
              in="SourceAlpha"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dx={0}
              dy={0}
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation={3}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.340772509 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <linearGradient
            x1="69.9355104%"
            y1="48.0687094%"
            x2="-1.93851675%"
            y2="52.4060312%"
            id="linearGradient-21"
          >
            <stop stopColor="#43A047" offset="0%" />
            <stop stopColor="#378577" offset="100%" />
          </linearGradient>
          <polygon
            id="path-22"
            points="0 0 205.155688 0 229.683594 53.4048507 205.155688 100 0 100"
          />
          <filter
            x="-7.6%"
            y="-22.5%"
            width="123.9%"
            height="155.0%"
            filterUnits="objectBoundingBox"
            id="filter-23"
          >
            <feOffset dx={10} dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation={7.5}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0.196078431   0 0 0 0 0.239215686   0 0 0 0 0.454901961  0 0 0 0.0993263134 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
          <circle id="path-24" cx={14} cy={14} r={14} />
          <filter
            x="-37.5%"
            y="-37.5%"
            width="175.0%"
            height="175.0%"
            filterUnits="objectBoundingBox"
            id="filter-25"
          >
            <feMorphology
              radius={1.5}
              operator="dilate"
              in="SourceAlpha"
              result="shadowSpreadOuter1"
            />
            <feOffset
              dx={0}
              dy={0}
              in="shadowSpreadOuter1"
              result="shadowOffsetOuter1"
            />
            <feGaussianBlur
              stdDeviation={3}
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feComposite
              in="shadowBlurOuter1"
              in2="SourceAlpha"
              operator="out"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.340772509 0"
              type="matrix"
              in="shadowBlurOuter1"
            />
          </filter>
        </defs>
        <g
          id="hover-/-active"
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
        >
          <g id="Illustration" transform="translate(0.000000, -18.000000)">
            <g id="Group" transform="translate(-329.000000, 18.000000)">
              <g id="house-base">
                <path
                  d="M1380.82593,427.169426 C1326.79182,558.148151 1349.45372,567.275114 1225.6843,607.327728 C1124.85404,639.957258 1055.48201,654.450771 855.89998,636.547252 C656.320177,618.641509 469.494319,440.120881 524.869538,240.874699 C580.24253,41.6307426 815.408437,-72.8774574 1103.92454,52.0599984 C1392.44064,176.997454 1434.86227,296.190701 1380.82593,427.169426 Z"
                  id="Shape"
                  fillOpacity={0.25}
                  fill="url(#linearGradient-1)"
                  fillRule="nonzero"
                />
                <polygon
                  id="Fill-1"
                  fill="#F5F5F7"
                  points="0 955.535 2669 955.535 2669 566.535 0 566.535"
                />
                <path
                  d="M1055.78926,611.331513 C1072.13244,611.920938 1107.48324,609.937888 1123.57986,604.867901 C1139.834,599.748302 1155.82497,597.005989 1171.8836,590.879339 C1174.68628,589.810069 1183.84576,585.426893 1184.36691,579.250798 C1184.54876,577.095758 1185.73274,573.087137 1184.13244,572.752126 C1165.60331,568.873194 1109.19434,567.369493 1090.45592,566.33864 C1071.7175,565.307787 1072.2193,565.399776 1044.31657,565.060461 C1033.0696,564.923691 1018.8382,564.300212 1009.00034,573.894887 C1003.30435,579.450076 1001.307,594.885749 1009.04724,599.939806 C1013.85627,603.079909 1008.26893,607.126977 1016.86283,608.228954 C1026.99595,609.726849 1039.97143,610.761035 1055.78926,611.331513 Z"
                  id="Path-2"
                  fill="#D0D0D7"
                  transform="translate(1094.458942, 588.216559) rotate(-3.000000) translate(-1094.458942, -588.216559) "
                />
                <polygon
                  id="Fill-39"
                  fill="#F5F5F7"
                  points="666.174 264.746 666.174 599.746 781.174 603.746 781.174 253.746"
                />
                <polygon
                  id="Fill-40"
                  fill="#9CA2C4"
                  points="781.174 253.746 837.174 268.746 837.174 584.079 781.174 603.746"
                />
                <polygon
                  id="Fill-41"
                  fill="#9CA2C4"
                  points="945.2365 359.746 945.1745 497.079 961.8405 611.079 961.8405 377.079 1021.8405 373.079 951.8405 359.746"
                />
                <g id="Group-70" transform="translate(649.000000, 96.746000)">
                  <path
                    d="M301.8409,263 L372.8409,276.333 L380.1739,275 L380.1739,243.214 C380.1739,243.072 380.1449,242.934 380.0869,242.805 L369.1059,218.258 C368.9449,217.898 368.5869,217.667 368.1929,217.667 L334.8949,217.667 C334.4639,217.667 334.0819,217.392 333.9459,216.982 L332.4019,212.351 C332.2659,211.942 331.8839,211.667 331.4529,211.667 L315.2439,211.667 C314.9859,211.667 314.7369,211.566 314.5499,211.387 L297.0189,194.505 C296.9019,194.393 296.7589,194.31 296.6039,194.265 L225.5069,173.667 L301.8409,263 Z"
                    id="Fill-42"
                    fillOpacity={0.850000024}
                    fill="#323D74"
                  />
                  <polygon
                    id="Fill-44"
                    fill="#D0D0D7"
                    points="313.007 280.5 313.007 374.5 403.507 374.5 403.507 273.167"
                  />
                  <polyline
                    id="Fill-46"
                    fill="#F5F5F7"
                    points="312.007 280.5 312.007 514.333 403.507 517 403.507 273.167 313.007 280.5"
                  />
                  <path
                    d="M403.507,273.167 L442.228,285.528 C442.643,285.66 442.924,286.045 442.924,286.48 L442.924,498 L403.507,517 L403.507,273.167 Z"
                    id="Fill-48"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M192.8409,143.667 L132.1739,124.667 L132.1739,157 L191.5799,172.994 C192.2159,173.165 192.8409,172.687 192.8409,172.028 L192.8409,143.667 Z"
                    id="Fill-50"
                    fillOpacity={0.850000024}
                    fill="#323D74"
                  />
                  <polygon
                    id="Fill-52"
                    fill="#9CA2C4"
                    points="37.174 98.5 37.174 136 133 125.667 133 88"
                  />
                  <polygon
                    id="Fill-54"
                    fill="#646D9A"
                    points="176.174 139.5 176.174 101.271845 132.174 87 132.174 125.398398"
                  />
                  <polygon
                    id="Fill-56"
                    fill="#757FB0"
                    points="16.174 139 23.674 138 23.674 100.5 16.174 101"
                  />
                  <polygon
                    id="Fill-58"
                    fill="#4E5888"
                    points="183.674 104.5 183.674 142 192.841 144.667 192.841 107.5"
                  />
                  <path
                    d="M75.8263,0.8232 L32.1743,82.0002 L1.0003,101.1492 C0.0903,101.7092 0.5743,103.1152 1.6373,102.9952 L134.1743,88.0002 L119.1743,72.0002 L77.5873,0.7882 C77.1963,0.0942 76.1893,0.1132 75.8263,0.8232"
                    id="Fill-60"
                    fill="#ACB2D0"
                  />
                  <path
                    d="M119.174,72 L119.048,71.785 L119.328,74.492 L29.244,83.799 L1,101.149 C0.09,101.709 0.574,103.115 1.637,102.995 L134.174,88 L119.174,72 Z"
                    id="Fill-139"
                    fill="#7981AD"
                  />
                  <path
                    d="M76.0065416,2.254 L74.461667,6.15792606 L74.461667,29.6556859 L61.1071068,30.991348 L58.6728214,35.5187892 L58.6728214,57.5366023 L46.6498009,58.6403787 L46.6498009,57.8777321 L43.5579904,63.627469 L43.5579904,83.8540933 L45.7871858,83.8540933 L31.9101097,85.2876628 L31.0186377,86.9459038 L28,88.7989289 L28,88.7989289 L123,78.7010758 L120.551286,76.418289 L120.393604,76.1462097 L108.829202,77.3406792 L108.829202,56.3441941 L105.737391,51.0510145 L105.737391,53.2142513 L93.0269584,54.3808944 L93.0269584,30.9058079 L93.9204917,30.8161454 L89.9351479,23.991489 L89.9351479,28.1097806 L77.5524469,29.3465048 L77.5524469,2.56215045 L76.0065416,2.254 Z M77.5524469,32.4527437 L89.9351479,31.2149889 L89.9351479,54.665341 L77.5524469,55.8020966 L77.5524469,32.4527437 Z M61.7636013,34.0316283 L74.461667,32.7629554 L74.461667,56.0855126 L61.7636013,57.2531864 L61.7636013,34.0316283 Z M93.0269584,57.4871334 L105.737391,56.3194596 L105.737391,77.6601663 L93.0269584,78.9731551 L93.0269584,57.4871334 Z M77.5524469,58.9083356 L89.9351479,57.7715799 L89.9351479,79.2926422 L77.5524469,80.5716212 L77.5524469,58.9083356 Z M61.7636013,60.3583947 L74.461667,59.1917515 L74.461667,80.8911082 L61.7636013,82.2040971 L61.7636013,60.3583947 Z M46.6498009,61.7466176 L58.6728214,60.6418107 L58.6728214,82.5225536 L46.6498009,83.7654614 L46.6498009,61.7466176 Z"
                    id="Fill-1"
                    fill="#7981AD"
                  />
                  <path
                    d="M78.3595,0.1221 L142.3785,26.8771 C142.5705,26.9571 142.7325,27.0951 142.8425,27.2721 L182.6735,91.5001 L205.7135,109.5131 C206.5945,110.2011 205.8525,111.5971 204.7885,111.2521 L133.1735,88.0001 L120.1735,74.0001 L77.1025,1.5351 C76.6345,0.7061 77.4805,-0.2449 78.3595,0.1221"
                    id="Fill-62"
                    fillOpacity={0.850000024}
                    fill="#323D74"
                  />
                  <path
                    d="M12.507,138.5635 L12.507,167.5645 C12.507,168.1555 13.017,168.6175 13.605,168.5595 L132.174,157.0005 L132.174,124.6675 L13.4,137.5695 C12.892,137.6255 12.507,138.0535 12.507,138.5635"
                    id="Fill-64"
                    fill="#7981AD"
                  />
                  <polygon
                    id="Fill-66"
                    fill="#FFFFFF"
                    points="103.507 273.667 103.507 507 312.841 514.333 296.174 400.333 296.174 263"
                  />
                  <path
                    d="M87.089,241.5889 L100.756,240.4259 C101.339,240.3759 101.841,240.8359 101.841,241.4219 L101.841,271.4339 C101.841,271.9449 101.455,272.3739 100.946,272.4289 L87.279,273.8829 C86.689,273.9449 86.174,273.4829 86.174,272.8879 L86.174,242.5849 C86.174,242.0659 86.571,241.6329 87.089,241.5889"
                    id="Fill-136"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M300.8042,263.1099 C301.6342,263.0659 302.0502,262.0859 301.5052,261.4579 L226.1112,174.3639 C225.7702,173.9709 225.1842,173.9039 224.7642,174.2129 L97.5072,267.6669 L88.7045898,273.754 C87.7615898,274.259 87.4732,274.6899 88.5402,274.6309 L300.8042,263.1099 Z"
                    id="Fill-68"
                    fill="#646D9A"
                  />
                </g>
                <path
                  d="M753.174,421.746 C753.174,421.746 739.174,409.079 723.174,409.079 C707.174,409.079 696.507,424.413 696.507,424.413 L696.507,598.413 L753.174,602.079 L753.174,421.746 Z"
                  id="Fill-71"
                  fill="#9CA2C4"
                />
                <g id="Group-79" transform="translate(79.000000, 275.746000)">
                  <path
                    d="M668.507,326.667 L619.841,326 C619.841,326 470.507,170 273.841,116 C77.174,62 125.174,64.667 125.174,64.667 L451.174,159.333 L578.507,240 L668.507,326.667 Z"
                    id="Fill-73"
                    fill="url(#linearGradient-2)"
                  />
                  <path
                    d="M674.507,326.333 L674.507,320.333 C674.507,320.333 531.174,169.667 355.174,105.667 C179.174,41.667 99.841,51.667 99.841,51.667 L70.507,47.667 L82.507,85.667 C82.507,85.667 276.958,111.812 381.174,143 C563.841,197.667 663.174,326.333 663.174,326.333 L674.507,326.333 Z"
                    id="Fill-77"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M662.061421,332.333 L673.507,332.333 L673.507,326.196622 C673.507,326.196622 528.750162,172.106026 351.001818,106.651324 C173.253474,41.1966217 93.1323974,51.4239189 93.1323974,51.4239189 L63.507,47.333 L75.6262053,86.1967293 C75.6262053,86.1967293 272.008838,112.935998 377.260096,144.832892 C561.741669,200.742458 662.061421,332.333 662.061421,332.333"
                    id="Fill-77"
                    fill="url(#linearGradient-3)"
                  />
                  <path
                    d="M674.174,162.667 C674.174,162.667 296.174,36 92.841,8 C-110.493,-20 98.841,52.667 98.841,52.667 C98.841,52.667 255.507,81.333 376.841,113.333 C498.174,145.333 674.174,198 674.174,198 L674.174,162.667 Z"
                    id="Fill-75"
                    fill="url(#linearGradient-4)"
                  />
                  <path
                    d="M673.174,165.423725 C673.174,165.423725 293.579997,35.8026987 89.389554,7.14970501 C-114.801893,-21.5032886 95.4148556,52.8583931 95.4148556,52.8583931 C95.4148556,52.8583931 252.741507,82.1929187 374.587165,114.939197 C496.431819,147.685476 673.174,201.580733 673.174,201.580733 L673.174,165.423725 Z"
                    id="Fill-75"
                    fill="url(#linearGradient-5)"
                  />
                </g>
                <g
                  id="Group-88"
                  transform="translate(762.000000, 489.746000)"
                  fill="#F5F5F7"
                >
                  <path
                    d="M7.174,112.5 L7.174,47.5 L0.674,3 C0.674,3 9.174,0 16.674,0 C24.174,0 32.674,4 32.674,4 L37.674,47 L37.674,113.5 L7.174,112.5 Z"
                    id="Fill-80"
                  />
                  <path
                    d="M51.674,113.5 L51.674,48.5 L45.174,4 C45.174,4 53.674,1 61.174,1 C68.674,1 77.174,5 77.174,5 L82.174,48 L82.174,114.5 L51.674,113.5 Z"
                    id="Fill-82"
                  />
                  <path
                    d="M97.174,114.5 L97.174,49.5 L90.674,5 C90.674,5 99.174,2 106.674,2 C114.174,2 122.674,6 122.674,6 L127.674,49 L127.674,115.5 L97.174,114.5 Z"
                    id="Fill-84"
                  />
                  <path
                    d="M144.674,117 L144.674,52 L138.174,7.5 C138.174,7.5 146.674,4.5 154.174,4.5 C161.674,4.5 170.174,8.5 170.174,8.5 L175.174,51.5 L175.174,118 L144.674,117 Z"
                    id="Fill-86"
                  />
                </g>
                <polygon
                  id="Fill-122"
                  fill="#9CA2C4"
                  points="839.174 524.246 816.174 524.246 816.174 571.246 841.174 571.246 841.174 540.246"
                />
                <polygon
                  id="Fill-123"
                  fill="#9CA2C4"
                  points="885.174 525.246 862.174 525.246 862.174 572.246 887.174 572.246 887.174 541.246"
                />
                <path
                  d="M829.174,520.413 L829.174,577.079"
                  id="Stroke-124"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <path
                  d="M814.507,539.413 L843.841,539.413"
                  id="Stroke-125"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <path
                  d="M814.507,556.413 L843.841,556.413"
                  id="Stroke-126"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <path
                  d="M874.174,520.413 L874.174,577.079"
                  id="Stroke-127"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <path
                  d="M859.507,539.413 L888.841,539.413"
                  id="Stroke-128"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <path
                  d="M859.507,556.413 L888.841,556.413"
                  id="Stroke-129"
                  stroke="#F5F5F7"
                  strokeWidth={3}
                />
                <g
                  id="Group-138"
                  transform="translate(699.000000, 285.746000)"
                  fill="#9CA2C4"
                >
                  <path
                    d="M6.089,4.9219 L19.756,3.7589 C20.339,3.7089 20.841,4.1699 20.841,4.7559 L20.841,22.7679 C20.841,23.2779 20.455,23.7079 19.946,23.7619 L6.279,25.2159 C5.689,25.2779 5.174,24.8159 5.174,24.2219 L5.174,5.9189 C5.174,5.3999 5.571,4.9659 6.089,4.9219"
                    id="Fill-130"
                  />
                  <path
                    d="M32.422,1.5889 L46.089,0.4259 C46.673,0.3759 47.174,0.8359 47.174,1.4219 L47.174,19.4339 C47.174,19.9449 46.788,20.3739 46.279,20.4289 L32.613,21.8829 C32.023,21.9449 31.507,21.4829 31.507,20.8879 L31.507,2.5849 C31.507,2.0659 31.905,1.6329 32.422,1.5889"
                    id="Fill-132"
                  />
                  <path
                    d="M1.089,55.9219 L14.756,54.7589 C15.339,54.7089 15.841,55.1699 15.841,55.7559 L15.841,85.1009 C15.841,85.6119 15.455,86.0409 14.946,86.0949 L1.279,87.5489 C0.689,87.6119 0.174,87.1489 0.174,86.5549 L0.174,56.9189 C0.174,56.3999 0.571,55.9659 1.089,55.9219"
                    id="Fill-134"
                  />
                </g>
                <g id="Group-189" transform="translate(803.000000, 308.746000)">
                  <path
                    d="M4.8409,27.9375 L4.8409,49.9335 C4.8409,50.5115 5.3279,50.9685 5.9039,50.9315 L28.9039,49.3935 C29.4309,49.3595 29.8409,48.9225 29.8409,48.3955 L29.8409,26.3995 C29.8409,25.8225 29.3529,25.3645 28.7769,25.4015 L5.7769,26.9405 C5.2499,26.9735 4.8409,27.4105 4.8409,27.9375"
                    id="Fill-141"
                    fillOpacity={0.699999988}
                    fill="#455085"
                  />
                  <path
                    d="M17.8409,23.667 L17.8409,54.333"
                    id="Stroke-143"
                    stroke="#646D9A"
                    strokeWidth={3}
                  />
                  <path
                    d="M2.8409,39.333 L34.1739,37.667"
                    id="Stroke-145"
                    stroke="#646D9A"
                    strokeWidth={3}
                  />
                  <path
                    d="M50.174,25.9375 L50.174,47.9335 C50.174,48.5115 50.661,48.9685 51.238,48.9315 L74.238,47.3935 C74.765,47.3595 75.174,46.9225 75.174,46.3955 L75.174,24.3995 C75.174,23.8225 74.687,23.3645 74.11,23.4015 L51.11,24.9405 C50.583,24.9735 50.174,25.4105 50.174,25.9375"
                    id="Fill-147"
                    fillOpacity={0.699999988}
                    fill="#455085"
                  />
                  <path
                    d="M63.174,21.667 L63.174,52.333"
                    id="Stroke-149"
                    stroke="#646D9A"
                    strokeWidth={3}
                  />
                  <path
                    d="M48.174,37.333 L79.507,35.667"
                    id="Stroke-151"
                    stroke="#646D9A"
                    strokeWidth={3}
                  />
                  <polygon
                    id="Fill-153"
                    fillOpacity={0.699999988}
                    fill="#455085"
                    points="17.507 6.333 39.507 24.667 48.174 17 34.841 5"
                  />
                  <polygon
                    id="Fill-155"
                    fillOpacity={0.699999988}
                    fill="#455085"
                    points="58.8409 6.333 80.8409 23.667 90.5069 18 76.1739 5"
                  />
                  <path
                    d="M19.507,7 L0.841,21.667"
                    id="Stroke-157"
                    stroke="#545E90"
                    strokeWidth={3}
                  />
                  <path
                    d="M60.007,7 L39.341,24.667"
                    id="Stroke-159"
                    stroke="#545E90"
                    strokeWidth={3}
                  />
                  <polygon
                    id="Fill-161"
                    fillOpacity={0.658486187}
                    fill="#7078A4"
                    points="121.507 0.3506 140.174 26.3326 165.174 26.3326 179.402 0.3506"
                  />
                  <polygon
                    id="Fill-163"
                    fillOpacity={0.658486187}
                    fill="#7078A4"
                    points="215.1056 6.2578 180.8946 6.2578 190.1736 26.9998 202.1736 26.9998"
                  />
                  <polygon
                    id="Fill-165"
                    fill="#9CA2C4"
                    points="181.507 97.667 181.507 147 218.841 146 218.841 95.667"
                  />
                  <polygon
                    id="Fill-167"
                    fill="#9CA2C4"
                    points="181.507 210.333 181.507 259.667 218.841 260.667 218.841 210.333"
                  />
                  <polygon
                    id="Fill-169"
                    fill="#8088AE"
                    points="261.507 299 261.507 212.333 278.174 209 278.174 291"
                  />
                  <polygon
                    id="Fill-171"
                    fill="#8088AE"
                    points="261.507 144.333 261.507 95.667 278.174 98.333 278.174 143.333"
                  />
                  <path
                    d="M200.507,93 L200.507,149.667"
                    id="Stroke-173"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <path
                    d="M176.8409,115 L222.1739,113"
                    id="Stroke-175"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <path
                    d="M176.8409,132 L222.1739,131"
                    id="Stroke-177"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <path
                    d="M200.507,205.667 L200.507,262.333"
                    id="Stroke-179"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <path
                    d="M176.8409,226.667 L222.1739,227.667"
                    id="Stroke-181"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <path
                    d="M176.8409,243.667 L222.1739,244.667"
                    id="Stroke-183"
                    stroke="#F5F5F7"
                    strokeWidth={3}
                  />
                  <polygon
                    id="Fill-185"
                    fillOpacity={0.658486187}
                    fill="#7078A4"
                    points="173.507 49.333 184.174 51.333 184.174 29 173.507 24.333"
                  />
                  <polygon
                    id="Fill-187"
                    fillOpacity={0.658486187}
                    fill="#7078A4"
                    points="208.174 54.4766 218.841 56.3326 218.841 36.6666 208.174 32.3326"
                  />
                </g>
                <g id="Group-121" transform="translate(763.000000, 401.746000)">
                  <path
                    d="M2.174,9.667 L2.174,56.973 C2.174,57.535 2.639,57.987 3.201,57.9733167 L25.867,57.359 C26.409,57.345 26.841,56.901 26.841,56.36 L26.841,9.667 C26.841,9.114 26.393,8.667 25.841,8.667 L3.174,8.667 C2.621,8.667 2.174,9.114 2.174,9.667"
                    id="Fill-89"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M45.507,8.667 L45.507,55.973 C45.507,56.535 45.972,56.987 46.534,56.9733167 L69.201,56.359 C69.742,56.345 70.174,55.901 70.174,55.36 L70.174,8.667 C70.174,8.114 69.727,7.667 69.174,7.667 L46.507,7.667 C45.955,7.667 45.507,8.114 45.507,8.667"
                    id="Fill-91"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M90.174,6.667 L90.174,53.973 C90.174,54.535 90.639,54.987 91.201,54.9733167 L113.867,54.359 C114.409,54.345 114.841,53.901 114.841,53.36 L114.841,6.667 C114.841,6.114 114.393,5.667 113.841,5.667 L91.174,5.667 C90.621,5.667 90.174,6.114 90.174,6.667"
                    id="Fill-93"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M136.8409,5.667 L136.8409,52.973 C136.8409,53.535 137.3049,53.987 137.8669,53.9733167 L160.5339,53.359 C161.0759,53.345 161.5069,52.901 161.5069,52.36 L161.5069,5.667 C161.5069,5.114 161.0599,4.667 160.5069,4.667 L137.8409,4.667 C137.2879,4.667 136.8409,5.114 136.8409,5.667"
                    id="Fill-95"
                    fill="#9CA2C4"
                  />
                  <path
                    d="M14.507,6 L14.507,62.667"
                    id="Stroke-97"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M0.8409,25 L30.1739,25"
                    id="Stroke-99"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M0.8409,42 L30.1739,42"
                    id="Stroke-101"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M58.174,5 L58.174,61.667"
                    id="Stroke-103"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M44.507,24 L73.841,24"
                    id="Stroke-105"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M44.507,41 L73.841,41"
                    id="Stroke-107"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M102.8409,3 L102.8409,59.667"
                    id="Stroke-109"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M88.174,22 L117.507,22"
                    id="Stroke-111"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M88.174,39 L117.507,39"
                    id="Stroke-113"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M149.174,0 L149.174,56.667"
                    id="Stroke-115"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M135.507,19 L164.841,19"
                    id="Stroke-117"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                  <path
                    d="M135.507,36 L164.841,36"
                    id="Stroke-119"
                    stroke="#FFFFFF"
                    strokeWidth={3}
                  />
                </g>
              </g>
              <RoomGroup
                id="theaterdeck-group"
                activeRoom={activeRoom}
                onClick={() => onRoomClick('theaterdeck')}
                transform="translate(570.000000, 477.000000)"
              >
                <Room id="theaterdeck">
                  <polygon
                    id="Path-6"
                    fill="#C0D2F2"
                    opacity={0.598}
                    style={{
                      mixBlendMode: 'lighten',
                    }}
                    points="183 1.13686838e-13 183 125.752267 391.6665 133.752267 390.833 1.13686838e-13 375.0005 1.13686838e-13"
                  />
                  <polygon
                    id="Path-6"
                    fill="url(#linearGradient-6)"
                    opacity={0.485}
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    points="183 1.13686838e-13 183 125.752267 391.6665 133.752267 390.833 1.13686838e-13 375.0005 1.13686838e-13"
                  />
                  <RoomText
                    id="theaterdeck-text"
                    activeRoom={activeRoom}
                    transform="translate(0.000000, 30.000000)"
                  >
                    <g id="Rectangle">
                      <use
                        fill="black"
                        fillOpacity={1}
                        filter="url(#filter-8)"
                        xlinkHref="#path-7"
                      />
                      <path
                        stroke="#B2C7F2"
                        strokeWidth={1}
                        d="M0.5,0.5 L0.5,99.5 L204.853846,99.5 L229.12647,53.3898044 L204.835116,0.5 L0.5,0.5 Z"
                        strokeLinejoin="square"
                        fill="#FFFFFF"
                        fillRule="evenodd"
                      />
                    </g>
                    <text
                      id="Theaterdeck"
                      fontFamily="Britannic-Bol"
                      fontSize={28}
                      fontWeight="bold"
                      line-spacing={43}
                      fill="#323D74"
                    >
                      <tspan x={30} y={60}>
                        {'Theaterdeck'}
                      </tspan>
                    </text>
                  </RoomText>
                </Room>
                <RoomPin
                  id="theaterdeck-pin"
                  activeRoom={activeRoom}
                  transform="translate(331.000000, 70.000000)"
                >
                  <g id="Oval-3-Copy">
                    <use
                      fill="black"
                      fillOpacity={1}
                      filter="url(#filter-10)"
                      xlinkHref="#path-9"
                    />
                    <use
                      stroke="#FFFFFF"
                      strokeWidth={3}
                      fill="#5293CF"
                      fillRule="evenodd"
                      xlinkHref="#path-9"
                    />
                  </g>
                </RoomPin>
              </RoomGroup>
              <RoomGroup
                id="sonnendeck-group"
                activeRoom={activeRoom}
                onClick={() => onRoomClick('sonnendeck')}
                transform="translate(570.000000, 270.000000)"
              >
                <Room id="sonnendeck">
                  <polygon
                    id="Path-4"
                    fill="#EA8F2B"
                    opacity={0.467}
                    style={{
                      mixBlendMode: 'normal',
                    }}
                    points="167 101.869659 304.225586 0.102539062 375.889648 20.8486328 394.728 38.8696592 412.5615 38.8696592 413.291016 44.0576172 448.221 44.4851735 459.471 69.9851735 459.304687 101.698242 449.944336 102.220703 381.471 89.9851735"
                  />
                  <polygon
                    id="Path-5"
                    fillOpacity={0.612}
                    fill="#B1A57C"
                    points="375.227051 90.104248 375.227051 109.272318 182.910889 116.958288 182.910889 99.5966797"
                  />
                  <polygon
                    id="Path-4"
                    fill="url(#linearGradient-11)"
                    opacity={0.322}
                    points="168 99.8696592 304.353492 0 375.7399 20.4861735 393.728 37.8696592 411.5615 37.8696592 413.570801 44.4624023 447.8266 44.2389735 459.461914 69.5078125 458.8949 101.981173 482.651367 99.7675781 522.179942 112.231267 521.645 116.981173 482.721 105.235173 389.721 111.235173 373.721 108.235173 182.458391 116.231267 182.458391 99.8696592"
                  />
                  <RoomText
                    id="sonnendeck-text"
                    activeRoom={activeRoom}
                  >
                    <g id="Rectangle">
                      <use
                        fill="black"
                        fillOpacity={1}
                        filter="url(#filter-13)"
                        xlinkHref="#path-12"
                      />
                      <path
                        stroke="#B2C7F2"
                        strokeWidth={1}
                        d="M0.5,0.5 L0.5,99.5 L204.853846,99.5 L229.12647,53.3898044 L204.835116,0.5 L0.5,0.5 Z"
                        strokeLinejoin="square"
                        fill="#FFFFFF"
                        fillRule="evenodd"
                      />
                    </g>
                    <text
                      id="Sonnendeck"
                      fontFamily="Britannic-Bol"
                      fontSize={28}
                      fontWeight="bold"
                      line-spacing={43}
                      fill="#323D74"
                    >
                      <tspan x={30} y={60}>
                        {'Sonnendeck'}
                      </tspan>
                    </text>
                  </RoomText>
                </Room>
                <RoomPin
                  id="sonnendeck-pin"
                  activeRoom={activeRoom}
                  transform="translate(385.000000, 26.000000)"
                >
                  <g id="Oval-3-Copy">
                    <use
                      fill="black"
                      fillOpacity={1}
                      filter="url(#filter-15)"
                      xlinkHref="#path-14"
                    />
                    <use
                      stroke="#FFFFFF"
                      strokeWidth={3}
                      fill="#F6B268"
                      fillRule="evenodd"
                      xlinkHref="#path-14"
                    />
                  </g>
                </RoomPin>
              </RoomGroup>
              <RoomGroup
                id="brueckendeck-group"
                activeRoom={activeRoom}
                onClick={() => onRoomClick('brueckendeck')}
                transform="translate(569.000000, 360.000000)"
              >
                <Room id="brueckendeck">
                  <polygon
                    id="Path-3"
                    fill="#DEC0BB"
                    opacity={0.774}
                    style={{
                      mixBlendMode: 'lighten',
                    }}
                    points="183 10 183 117.326733 375.1745 117.326733 391.007 117.326733 482.507 117.326733 522 111.246 522 23 482.507 10.5 449.148638 12.120258 380.5 -2.27796509e-14 374.5 0.5"
                  />
                  <polygon
                    id="Path-3"
                    fill="url(#linearGradient-16)"
                    opacity={0.468}
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    points="183 10 183 117.326733 375.1745 117.326733 391.007 117.326733 482.507 117.326733 522 111.246 522 23 482.630859 10.4379883 449.148638 12.120258 380.5 -2.27796509e-14 374.5 0.5"
                  />
                  <RoomText
                    id="brueckendeck-text"
                    activeRoom={activeRoom}
                    transform="translate(0.000000, 17.000000)"
                  >
                    <g id="Rectangle">
                      <use
                        fill="black"
                        fillOpacity={1}
                        filter="url(#filter-18)"
                        xlinkHref="#path-17"
                      />
                      <path
                        stroke="#B2C7F2"
                        strokeWidth={1}
                        d="M0.5,0.5 L0.5,99.5 L204.853846,99.5 L229.12647,53.3898044 L204.835116,0.5 L0.5,0.5 Z"
                        strokeLinejoin="square"
                        fill="#FFFFFF"
                        fillRule="evenodd"
                      />
                    </g>
                    <text
                      id="Br\xFCckendeck"
                      fontFamily="Britannic-Bol"
                      fontSize={28}
                      fontWeight="bold"
                      line-spacing={43}
                      fill="#323D74"
                    >
                      <tspan x={30} y={60}>
                        {'Br\xFCckendeck'}
                      </tspan>
                    </text>
                  </RoomText>
                </Room>
                <RoomPin
                  id="brueckendeck-pin"
                  activeRoom={activeRoom}
                  transform="translate(270.000000, 56.000000)"
                >
                  <g id="Oval-3-Copy">
                    <use
                      fill="black"
                      fillOpacity={1}
                      filter="url(#filter-20)"
                      xlinkHref="#path-19"
                    />
                    <use
                      stroke="#FFFFFF"
                      strokeWidth={3}
                      fill="#CF6452"
                      fillRule="evenodd"
                      xlinkHref="#path-19"
                    />
                  </g>
                </RoomPin>
              </RoomGroup>
              <RoomGroup
                id="inselgarten-group"
                activeRoom={activeRoom}
                onClick={() => onRoomClick('wiese')}
                transform="translate(934.000000, 545.000000)"
              >
                <Room id="inselgarten" transform="translate(0.595703, 0.000000)">
                  <path
                    d="M157.349527,49.6972656 L157.349527,21 L692.901203,21.535 C674.903807,35.2836667 657.235839,47.465 639.897297,58.079 C613.889484,74 527.881672,123.779976 497.889484,129.889988 C477.894693,133.963329 368.23063,135 168.897297,133 L118,68.6982422 L157.349527,49.6972656 Z"
                    id="Path-7"
                    fill="url(#linearGradient-21)"
                    opacity={0.450}
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                  />
                  <RoomText
                    id="inselgarten-text"
                    activeRoom={activeRoom}
                    transform="translate(0.897297, 0.000000)"
                  >
                    <g id="Rectangle">
                      <use
                        fill="black"
                        fillOpacity={1}
                        filter="url(#filter-23)"
                        xlinkHref="#path-22"
                      />
                      <path
                        stroke="#B2C7F2"
                        strokeWidth={1}
                        d="M0.5,0.5 L0.5,99.5 L204.853846,99.5 L229.12647,53.3898044 L204.835116,0.5 L0.5,0.5 Z"
                        strokeLinejoin="square"
                        fill="#FFFFFF"
                        fillRule="evenodd"
                      />
                    </g>
                    <text
                      id="Inselgarten"
                      fontFamily="Britannic-Bol"
                      fontSize={28}
                      fontWeight="bold"
                      line-spacing={43}
                      fill="#323D74"
                    >
                      <tspan x={30} y={60}>
                        {'Wiese'}
                      </tspan>
                    </text>
                  </RoomText>
                </Room>
                <RoomPin
                  id="inselgarten-pin"
                  activeRoom={activeRoom}
                  transform="translate(224.404297, 7.000000)"
                >
                  <g id="Oval-3-Copy">
                    <use
                      fill="black"
                      fillOpacity={1}
                      filter="url(#filter-25)"
                      xlinkHref="#path-24"
                    />
                    <use
                      stroke="#FFFFFF"
                      strokeWidth={3}
                      fill="#378577"
                      fillRule="evenodd"
                      xlinkHref="#path-24"
                    />
                  </g>
                </RoomPin>
              </RoomGroup>
            </g>
          </g>
        </g>
      </svg>
      {/* </SvgContainerInner> */}
    </SvgContainer>
  )
}

export default House
